export var buttonVariantClass = {
    primary: "bg-primary text-white hover:bg-blueDarker border-primary",
    outline: "bg-white text-primary border-blueLighter/60 hover:border-primary hover:bg-ghostBlue",
    soft: "bg-green/20 text-sherpaMeadow border-successSoft hover:bg-green/20",
    ghost: "bg-transparent text-primary border-transparent hover:bg-sherpaMilk",
};
